<template>
  <div class="search-sorting-list">
    <template v-for="sortMethod in sorts">
      <label
        :key="sortMethod"
        :class="{'search-sorting-list__item': true, 'search-sorting-list__item--active': selectedSort === sortMethod }"
        @change="$emit('optionChanged')"
      >
        <input
          type="radio"
          :value="sortMethod"
          class="search-sorting-list__btn"
          v-model="selectedSort"
        >
        <span class="search-sorting-list__custom-radio">
          <img src="/img/svgo/check-rounded.svg" class="search-sorting-list__checkmark"/>
        </span>
        {{ $t(`search.filters.sorting-${sortMethod}`) }}
      </label>
      <div :key="sortMethod + 'br'" class="search-sorting-list__separator"/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SearchSortingList',
  props: {
    sorts: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions(['FETCH_SEARCH_PAGE_INFO', 'SET_SEARCH_SORT_METHOD'])
  },
  computed: {
    ...mapState({
      searchSort: state => state.search.searchSort
    }),
    selectedSort: {
      get () {
        return this.searchSort
      },
      set (value) {
        this.SET_SEARCH_SORT_METHOD(value)
        this.FETCH_SEARCH_PAGE_INFO(true)
      }
    }
  }
}
</script>

<style scoped lang="sass">
input[type="radio"]
  display: none

.search-sorting-list
  display: flex
  flex-direction: column
  width: 100%
  gap: 5px
  background-color: $page-bg

  +mmin($tablet--hor)
    width: 200px
    padding: 10px 10px 10px 15px
    gap: 10px
    box-shadow: 0 2px 10px 0 rgba(144, 144, 144, 0.25)
    border-radius: 3px

  &__item
    display: flex
    align-items: center
    gap: 15px

    height: 50px
    width: 100%
    padding: 13px

    border: 1px solid $nd-border-color
    border-radius: 3px

    font-size: 16px
    cursor: pointer
    transition: 0.2s ease

    +mmin($tablet--hor)
      height: auto
      font-size: 14px
      line-height: 100%
      letter-spacing: 0
      text-align: center

      padding: 0
      border: none

    &--active
      font-weight: 500
      border-color: #909090

      .search-sorting-list__custom-radio
        background-color: #34a853
        border-color: #34a853

      .search-sorting-list__checkmark
        display: block

  &__separator
    width: 100%
    height: 1px

    background-color: #E7E7E7

    &:last-child
      display: none

  &__custom-radio
    width: 20px
    min-width: 20px
    height: 20px
    border-radius: 50%
    border: 1px solid #ddd
    background-color: white
    position: relative
    transition: 0.3s

  &__checkmark
    position: absolute
    width: 20px
    height: 20px
    display: none
</style>
